<div class="login-page d-flex flex-column flex-root" id="kt_app_root">
  <div class="d-flex flex-column flex-lg-row flex-column-fluid min-vh-100">
    <!-- Form Side -->
    <div
      class="d-flex flex-column flex-lg-row-fluid w-lg-50 p-10 order-2 order-lg-1"
    >
      <div class="d-flex flex-center flex-column flex-lg-row-fluid">
        <div class="w-lg-500px p-10">
          <div class="text-center mb-11">
            <h1 class="text-gray-900 fw-bolder mb-3" style="font-size: 2.25rem">
              {{ "welcomeText" | translate }}
            </h1>

            <div class="text-gray-500 fw-semibold" style="font-size: 1.25rem">
              {{ "descriptionText" | translate }}
            </div>
          </div>
          <!-- Login -->
          <form
            *ngIf="
              !showFirstLogin &&
              !show2FA &&
              !showLoginWithMail &&
              !showLoginWithGoogle
            "
            (submit)="submitLogin($event)"
            class="form w-100"
            novalidate="novalidate"
            id="kt_sign_in_form"
            data-kt-redirect-url="#"
            action="#"
          >
            <div class="fv-row mb-8">
              <input
                [(ngModel)]="loginForm.email"
                type="text"
                placeholder="Email"
                name="email"
                autocomplete="off"
                class="form-control bg-transparent"
              />
            </div>
            <div class="fv-row mb-8">
              <input
                [(ngModel)]="loginForm.password"
                type="password"
                placeholder="Password"
                name="password"
                autocomplete="off"
                class="form-control bg-transparent"
              />
            </div>
            <div class="d-grid mb-10">
              <button
                type="submit"
                class="btn btn-primary cursor-pointer"
                [disabled]="loginLoading"
              >
                <span class="indicator-label">
                  <ng-container *ngIf="loginLoading; else showLoginText">
                    {{ "pleaseWait" | translate }}
                    <span
                      class="spinner-border spinner-border-sm align-middle ms-2"
                    ></span>
                  </ng-container>
                  <ng-template #showLoginText>
                    {{ "login" | translate }}</ng-template
                  >
                </span>
              </button>
            </div>
          </form>
          <!-- First Login -->
          <form
            *ngIf="showFirstLogin && !show2FA"
            [formGroup]="firstLoginForm"
            (submit)="submitFirstLogin($event)"
            class="form w-100"
            novalidate="novalidate"
            id="kt_sign_in_form"
            data-kt-redirect-url="#"
            action="#"
          >
            <div class="fw-semibold fs-4 mt-4">
              {{ "firstLogin" | translate }}
            </div>
            <div class="row">
              <div class="col-md-12 mt-4">
                <div class="form-floating">
                  <select
                    formControlName="secretQuestion"
                    class="form-select"
                    id="inputSecretQuestion"
                    (change)="onSecretQuestionChange($event)"
                  >
                    <option [ngValue]="null" selected disabled>
                      {{ "secretQuestion" | translate }}
                    </option>
                    <option
                      *ngFor="let secretQuestion of secretQuestions"
                      [value]="secretQuestion.secretQuestion"
                    >
                      {{ secretQuestion.secretQuestion }}
                    </option>
                  </select>

                  <label for="inputSecretQuestion">{{
                    "secretQuestion" | translate
                  }}</label>
                  <div
                    *ngIf="isFirstLoginControlInvalid('secretQuestion')"
                    class="text-danger"
                  >
                    <div
                      *ngIf="firstLoginForm.get('secretQuestion')?.errors?.['required']"
                    >
                      {{ "secretQuestionRequired" | translate }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-12 mt-4">
                <div class="form-floating">
                  <input
                    formControlName="answer"
                    class="form-control"
                    id="inputAnswer"
                    type="text"
                    placeholder="Secret answer"
                  />
                  <label for="inputAnswer">{{
                    "secretAnswer" | translate
                  }}</label>
                  <div
                    *ngIf="isFirstLoginControlInvalid('answer')"
                    class="text-danger"
                  >
                    <div
                      *ngIf="firstLoginForm.get('answer')?.errors?.['required']"
                    >
                      {{ "secretAnswerRequired" | translate }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-12 mt-4">
                <div class="form-floating">
                  <input
                    formControlName="password"
                    class="form-control"
                    id="inputNewPassword"
                    type="password"
                    placeholder="Secret password"
                  />
                  <label for="inputNewPassword">{{
                    "newPassword" | translate
                  }}</label>
                  <div
                    *ngIf="isFirstLoginControlInvalid('password')"
                    class="text-danger"
                  >
                    <div
                      *ngIf="firstLoginForm.get('password')?.errors?.['required']"
                    >
                      {{ "newPasswordRequired" | translate }}
                    </div>
                    <div
                      *ngIf="firstLoginForm.get('password')?.errors?.['minlength']"
                    >
                      {{ "newPasswordMustBeAtLeast8Characters" | translate }}
                    </div>
                    <div
                      *ngIf="firstLoginForm.get('password')?.errors?.['pattern']"
                    >
                      {{
                        "newPasswordMustContainAtLeastOneUppercaseLetterAndOneSpecialCharacter"
                          | translate
                      }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-12 mt-4">
                <div class="form-floating">
                  <input
                    formControlName="confirmPassword"
                    class="form-control"
                    id="inputNewConfirmPassword"
                    type="password"
                    placeholder="Confirm Password"
                  />
                  <label for="inputNewConfirmPassword">{{
                    "confirmPassword" | translate
                  }}</label>
                  <div
                    *ngIf="isFirstLoginControlInvalid('confirmPassword')"
                    class="text-danger"
                  >
                    <div
                      *ngIf="firstLoginForm.get('confirmPassword')?.errors?.['required']"
                    >
                      {{ "confirmPasswordRequired" | translate }}
                    </div>
                    <div
                      *ngIf="firstLoginForm.get('confirmPassword')?.errors?.['minlength']"
                    >
                      {{
                        "confirmPasswordMustBeAtLeast8CharactersLong"
                          | translate
                      }}
                    </div>
                    <div
                      *ngIf="firstLoginForm.get('confirmPassword')?.errors?.['pattern']"
                    >
                      {{
                        "confirmPasswordMustContainAtLeastOneUppercaseLetterAndOneSpecialCharacter"
                          | translate
                      }}
                    </div>
                    <div
                      *ngIf="firstLoginForm.get('confirmPassword')?.errors?.['passwordMismatch']"
                    >
                      {{ "passwordsDoNotMatch" | translate }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="d-grid mb-10 mt-6">
              <button
                type="submit"
                class="btn btn-primary cursor-pointer"
                [disabled]="firstLoginLoading"
              >
                <span class="indicator-label">
                  <ng-container *ngIf="firstLoginLoading; else showLoginText">
                    {{ "pleaseWait" | translate }}
                    <span
                      class="spinner-border spinner-border-sm align-middle ms-2"
                    ></span>
                  </ng-container>
                  <ng-template #showLoginText>
                    {{ "submit" | translate }}
                  </ng-template>
                </span>
              </button>
            </div>
          </form>
          <!-- Two Factor Authentication -->
          <div *ngIf="show2FA && !showMailSection" class="two-factor-auth">
            <div class="fw-semibold fs-4">
              {{ "twoFactorAuthentication" | translate }}
            </div>
            <!-- Google Auth -->
            <div class="form-check form-switch mt-6">
              <input
                class="form-check-input"
                type="checkbox"
                role="switch"
                id="googleAuth"
                (change)="onGoogleAuthToggle()"
                data-bs-toggle="modal"
                [attr.data-bs-target]="'#createGoogleQrCodeModal'"
              />
              <label class="form-check-label" for="googleAuth">{{
                "googleAuthentication" | translate
              }}</label>
            </div>
            <!-- Mail Auth -->
            <div class="form-check form-switch mt-6">
              <input
                class="form-check-input"
                type="checkbox"
                role="switch"
                id="emailAuth"
                (change)="onMailAuthToggle($event)"
              />
              <label class="form-check-label" for="emailAuth">{{
                "emailAuthentication" | translate
              }}</label>
            </div>
            <div class="d-grid mt-6">
              <a [routerLink]="['/dashboard']" class="btn btn-primary">{{
                "skip2FA" | translate
              }}</a>
            </div>
          </div>
          <!-- Mail Authentication Section -->
          <form
            *ngIf="showMailSection"
            [formGroup]="mailCodeForm"
            (submit)="submitMailAuthCode($event)"
            class="form w-100"
            novalidate="novalidate"
            id="kt_sign_in_form"
            data-kt-redirect-url="#"
            action="#"
          >
            <div class="fw-semibold fs-4 mt-4">
              {{ "emailAuthentication" | translate }}
            </div>
            <div class="row">
              <div class="col-md-12 mt-4">
                <div class="form-floating">
                  <input
                    formControlName="code"
                    class="form-control"
                    id="inputCode"
                    type="text"
                    placeholder="Code"
                  />
                  <label for="inputCode">{{ "code" | translate }}</label>
                  <div
                    *ngIf="isFirstLoginControlInvalid('code')"
                    class="text-danger"
                  >
                    <div *ngIf="mailCodeForm.get('code')?.errors?.['required']">
                      {{ "codeIsRequired" | translate }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="d-grid mb-10 mt-6">
              <button
                type="submit"
                class="btn btn-primary cursor-pointer"
                [disabled]="mailAuthSectionLoading"
              >
                <span class="indicator-label">
                  <ng-container
                    *ngIf="mailAuthSectionLoading; else showLoginText"
                  >
                    {{ "pleaseWait" | translate }}
                    <span
                      class="spinner-border spinner-border-sm align-middle ms-2"
                    ></span>
                  </ng-container>
                  <ng-template #showLoginText>
                    {{ "submit" | translate }}
                  </ng-template>
                </span>
              </button>
            </div>
          </form>
          <!-- Login With Mail -->
          <form
            *ngIf="showLoginWithMail"
            [formGroup]="mailLoginForm"
            (submit)="submitMailLoginForm($event)"
            class="form w-100"
            novalidate="novalidate"
            id="kt_sign_in_form"
            data-kt-redirect-url="#"
            action="#"
          >
            <div class="form-floating mt-4">
              <input
                formControlName="code"
                class="form-control"
                id="inputCode"
                type="text"
                placeholder="Code"
              />
              <label for="inputCode">{{ "code" | translate }}</label>
              <div
                *ngIf="isMailLoginControlInvalid('code')"
                class="text-danger"
              >
                <div *ngIf="mailLoginForm.get('code')?.errors?.['required']">
                  {{ "codeIsRequired" | translate }}
                </div>
              </div>
            </div>
            <div class="d-grid mb-10 mt-4">
              <button
                type="submit"
                class="btn btn-primary cursor-pointer"
                [disabled]="loginWithMailLoading"
              >
                <span class="indicator-label">
                  <ng-container
                    *ngIf="loginWithMailLoading; else showLoginText"
                  >
                    {{ "pleaseWait" | translate }}
                    <span
                      class="spinner-border spinner-border-sm align-middle ms-2"
                    ></span>
                  </ng-container>
                  <ng-template #showLoginText>
                    {{ "submit" | translate }}
                  </ng-template>
                </span>
              </button>
            </div>
          </form>
          <!-- Login With Google -->
          <form
            *ngIf="showLoginWithGoogle"
            [formGroup]="googleLoginForm"
            (submit)="submitGoogleLoginForm($event)"
            class="form w-100"
            novalidate="novalidate"
            id="kt_sign_in_form"
            data-kt-redirect-url="#"
            action="#"
          >
            <div class="form-floating mt-4">
              <input
                formControlName="code"
                class="form-control"
                id="inputCode"
                type="text"
                placeholder="Code"
              />
              <label for="inputCode">{{ "code" | translate }}</label>
              <div
                *ngIf="isGoogleLoginControlInvalid('code')"
                class="text-danger"
              >
                <div *ngIf="mailLoginForm.get('code')?.errors?.['required']">
                  {{ "codeIsRequired" | translate }}
                </div>
              </div>
            </div>
            <div class="d-grid mb-10 mt-4">
              <button
                type="submit"
                class="btn btn-primary cursor-pointer"
                [disabled]="loginWithGoogleLoading"
              >
                <span class="indicator-label">
                  <ng-container
                    *ngIf="loginWithGoogleLoading; else showLoginText"
                  >
                    {{ "pleaseWait" | translate }}
                    <span
                      class="spinner-border spinner-border-sm align-middle ms-2"
                    ></span>
                  </ng-container>
                  <ng-template #showLoginText>
                    {{ "submit" | translate }}
                  </ng-template>
                </span>
              </button>
            </div>
          </form>

          <div
            class="w-lg-500px d-flex flex-stack justify-content-between mx-auto"
            style="justify-content: start; margin-top: -20px"
          >
            <!-- Languages -->
            <div class="me-11">
              <button
                class="btn btn-flex btn-link btn-color-gray-700 btn-active-color-primary rotate fs-base"
                data-kt-menu-trigger="click"
                data-kt-menu-placement="bottom-start"
                data-kt-menu-offset="0px, 0px"
              >
                <img
                  *ngIf="currentLanguageFlag"
                  data-kt-element="current-lang-flag"
                  class="rounded me-3 h-20px w-20px"
                  [src]="currentLanguageFlag"
                  loading="lazy"
                  [alt]="currentLanguageName"
                  width="20"
                  height="20"
                />
                <span data-kt-element="current-lang-name" class="me-1">
                  {{ currentLanguageName }}
                </span>
                <span class="d-flex flex-center rotate-180">
                  <i class="fa-solid fa-chevron-down text-muted"></i>
                </span>
              </button>

              <!-- Language Menu -->
              <div
                class="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-800 menu-state-bg-light-primary fw-semibold w-200px py-4 fs-7"
                data-kt-menu="true"
                id="kt_auth_lang_menu"
              >
                <div class="menu-item px-3" *ngFor="let lang of languages">
                  <a
                    href="#"
                    class="menu-link d-flex px-5"
                    (click)="setLanguage(lang)"
                  >
                    <span class="symbol symbol-20px me-4">
                      <img
                        class="rounded-1"
                        [src]="lang.flag"
                        alt="{{ lang.name }}"
                      />
                    </span>
                    <span>{{ lang.name }}</span>
                  </a>
                </div>
              </div>
            </div>

            <a
              class="forgot-password me-20"
              routerLink="/forgot-password"
              style="cursor: pointer"
              >{{ "loginForgotPassword" | translate }}</a
            >
          </div>
        </div>
      </div>
    </div>

    <!-- Image Side -->
    <div
      class="d-flex flex-lg-row-fluid w-lg-50 bgi-size-cover bgi-position-center order-1 order-lg-2"
      style="background-image: url(assets/media/misc/auth-bg.png)"
    >
      <div
        class="d-flex flex-column flex-center py-7 py-lg-15 px-5 px-md-15 w-100"
      >
        <div class="w-lg-500px d-flex justify-content-center mb-5">
          <img
            src="assets/media/telehealth.png"
            class="w-75"
            alt="Logo"
          />
        </div>

        <img
          class="d-none d-lg-block mx-auto w-275px w-md-50 w-xl-600px mt-lg-1 mb-10 mb-lg-10"
          src="assets/media/telehealth-logo.png"
          alt=""
        />
        <h1
          class="d-none d-lg-block text-white fs-2qx fw-bolder text-center mb-7"
        >
          Telehealth.Health
        </h1>
        <div class="d-none d-lg-block text-white fs-base text-center">
          {{ "descriptionText" | translate }}<br />
          v1.2.0 {{ currentYear }}
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Create Qr Code Modal -->
<div
  class="modal fade"
  id="createGoogleQrCodeModal"
  tabindex="-1"
  aria-labelledby="createGoogleQrCodeModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-sm">
    <div class="modal-content">
      <div class="modal-header">
        <h1 class="modal-title fs-2" id="createGoogleQrCodeModalLabel">
          {{ "qrCode" | translate }}
        </h1>
        <button
          type="button"
          class="btn-close cursor-pointer"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>
      </div>
      <div class="modal-body fs-4 text-center">
        <div
          *ngIf="!googleQrCodeDetails?.qrCodeImageUrl; else showQrCode"
          class="spinner-border qr-code-spinner text-danger"
          role="status"
        >
          <span class="visually-hidden">{{ "loading" | translate }}...</span>
        </div>
        <ng-template #showQrCode>
          <img
            [src]="googleQrCodeDetails.qrCodeImageUrl"
            class="w-100"
            alt="QR Code"
          />
          <form
            [formGroup]="googleQrCodeForm"
            (submit)="submitGoogleQrCodeForm($event)"
            class="form w-100"
            novalidate="novalidate"
            id="kt_sign_in_form"
            data-kt-redirect-url="#"
            action="#"
          >
            <div class="form-floating mt-4">
              <input
                formControlName="code"
                class="form-control"
                id="inputCode"
                type="text"
                placeholder="Code"
              />
              <label for="inputCode">{{ "code" | translate }}</label>
              <div
                *ngIf="isGoogleLoginControlInvalid('code')"
                class="text-danger"
              >
                <div *ngIf="googleQrCodeForm.get('code')?.errors?.['required']">
                  {{ "codeIsRequired" | translate }}
                </div>
              </div>
            </div>
            <div class="d-grid mb-10 mt-4">
              <button
                type="submit"
                class="btn btn-primary cursor-pointer"
                data-bs-dismiss="modal"
              >
                <span class="indicator-label">
                  {{ "submit" | translate }}
                </span>
              </button>
            </div>
          </form>
        </ng-template>
      </div>
    </div>
  </div>
</div>

<!-- Toast Message -->
<app-toast
  [message]="toastMessage"
  [type]="toastType"
  [showToast]="showToast"
></app-toast>
